import { render, staticRenderFns } from "./SOV.vue?vue&type=template&id=60639b9a&scoped=true"
import script from "./SOV.vue?vue&type=script&lang=js"
export * from "./SOV.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SOV.vue?vue&type=style&index=1&id=60639b9a&prod&scoped=true&lang=css"
import style2 from "./SOV.vue?vue&type=style&index=2&id=60639b9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60639b9a",
  null
  
)

export default component.exports